import type { IntlShape } from 'react-intl'

import SolidBellIcon from 'LuxKit/Icons/solid/SolidBellIcon'
import SolidBellSlashIcon from 'LuxKit/Icons/solid/SolidBellSlashIcon'
import { showAlertConfirmationSnackbar } from 'components/Common/Alerts/AlertConfirmationSnackbar'

/**
 * Shown after a destination is added to the user's watchlist.
 */
export function showDestinationWatchingSnackbar(intl: IntlShape, placeName: string) {
  showAlertConfirmationSnackbar({
    icon: <SolidBellIcon size="M" />,
    heading: intl.formatMessage({
      id: 'c6p6J7rpgAs9n7i2ocyz',
      defaultMessage: 'You’re watching {placeName}',
      description: 'Notification heading confirming the user now receives new offer alerts for the destination they just added to their watchlist',
    }, { placeName }),
    description: intl.formatMessage({
      id: '2OPgCeHn3ZELiH_mOEop',
      defaultMessage: 'You’ll be the first to know when new offers for {placeName} become available.',
      description: 'Notification body explaining that the user will be alerted first when new offers for the watched destination become available',
    }, { placeName }),
    manageAlertsLabel: intl.formatMessage({
      id: 'YBScUahyKY6Hzp55rSlz',
      defaultMessage: 'Manage alerts',
      description: 'Notification action that takes the user to their travel preferences page to manage destination offer alerts',
    }),
    confirmLabel: intl.formatMessage({
      id: 'u-TIQ3ag4V5cu88yi4PS',
      defaultMessage: 'Got it',
      description: 'Notification action that acknowledges and dismisses the destination watchlist confirmation message',
    }),
  })
}

/**
 * Shown after a destination is removed from the user's watchlist, offering an undo.
 */
export function showDestinationUnwatchedSnackbar(intl: IntlShape, placeName: string, onUndo: () => void) {
  showAlertConfirmationSnackbar({
    icon: <SolidBellSlashIcon size="M" />,
    heading: intl.formatMessage({
      id: 'KThNXG3ETWTtNiOh3nq6',
      defaultMessage: 'You’re no longer watching {placeName}',
      description: 'Notification heading confirming the user stopped receiving new offer alerts for the destination they just removed',
    }, { placeName }),
    description: intl.formatMessage({
      id: 'i_KUvS3xgud2kPTRqE_D',
      defaultMessage: 'We’ll stop notifying you about our best {placeName} offers as they become available.',
      description: 'Notification body explaining that offer alerts for the removed destination have stopped being sent to the user',
    }, { placeName }),
    manageAlertsLabel: intl.formatMessage({
      id: 'YBScUahyKY6Hzp55rSlz',
      defaultMessage: 'Manage alerts',
      description: 'Notification action that takes the user to their travel preferences page to manage destination offer alerts',
    }),
    confirmLabel: intl.formatMessage({
      id: 'm57lbcNP8ff9lJNQXNeV',
      defaultMessage: 'Undo',
      description: 'Notification action that restores the destination the user just removed from their watchlist',
    }),
    onConfirm: onUndo,
  }, 'neutral')
}
